<template>
  <div id="app-root">
    <SiteHeader />
    <main>
      <router-view />
    </main>
    <SiteFooter />
    <div class="rx-toast" :class="{ show: toast.show }">{{ toast.msg }}</div>
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
  name: 'App',
  components: { SiteHeader, SiteFooter },
  data() {
    return { toast: { show: false, msg: '' } }
  },
  created() {
    // 全局 toast：任何组件可 this.$root.$emit('toast', '文本')
    this.$root.$on('toast', (msg) => {
      this.toast.msg = msg
      this.toast.show = true
      clearTimeout(this._t)
      this._t = setTimeout(() => { this.toast.show = false }, 2000)
    })
  }
}
</script>

<style>
#app-root { display: flex; flex-direction: column; min-height: 100vh; }
main { flex: 1; }
</style>
